export const CLIENT_EVENTS = {
  updateDocumentField: "updateDocumentField",
  peerMutation: "peerMutation",
  previewEdit: "previewEdit",
};
